import {HttpRequest} from '../../settings/HttpRequest/HttpRequest';
import {DateFormat} from "../../settings/DateFormat/DateFormat";

export const CargaCFDIService = {
	Listar: (filtro, paginacion) => {
		console.log('PAGINACION', paginacion);
		console.log('FILTRO', filtro);
		let fecha = (filtro.fecha || null) ? DateFormat.FormatSql(filtro.fecha) : null;
		let fecha_inicio = (filtro.fecha_inicio || null) ? DateFormat.FormatSql(filtro.fecha_inicio) : null;
		let fecha_fin = (filtro.fecha_fin || null) ? DateFormat.FormatSql(filtro.fecha_fin) : null;
		
		let params = {
			filtro: {
				// id_empresa: filtro.id_empresa || null,
				empresa: filtro.empresa || null,
				cliente: filtro.cliente || null,
				id_cat_facturacion_status_sat: filtro.id_cat_facturacion_status_sat || null,
				id_cat_facturacion_status_pago: filtro.id_cat_facturacion_status_pago || null,
				id_cat_facturacion_plaza: filtro.id_cat_facturacion_plaza || null,
				anio: filtro.anio || null,
				periodo: filtro.periodo || null,
				serie: filtro.serie || null,
				folio: filtro.folio || null,
				uuid: filtro.uuid || null,
				fecha_inicio: fecha_inicio || null,
				fecha_fin: fecha_fin || null,
			},
			paginacion: {
				total: paginacion.total || null,
				page: paginacion.page || null,
				limit: paginacion.limit || null
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	ListarDownload: (filtro) => {
		console.log('FILTRO', filtro);
		let fecha = (filtro.fecha || null) ? DateFormat.FormatSql(filtro.fecha) : null;
		let fecha_inicio = (filtro.fecha_inicio || null) ? DateFormat.FormatSql(filtro.fecha_inicio) : null;
		let fecha_fin = (filtro.fecha_fin || null) ? DateFormat.FormatSql(filtro.fecha_fin) : null;
		
		let params = {
			filtro: {
				// id_empresa: filtro.id_empresa || null,
				empresa: filtro.empresa || null,
				cliente: filtro.cliente || null,
				id_cat_facturacion_status_sat: filtro.id_cat_facturacion_status_sat || null,
				id_cat_facturacion_status_pago: filtro.id_cat_facturacion_status_pago || null,
				id_cat_facturacion_plaza: filtro.id_cat_facturacion_plaza || null,
				anio: filtro.anio || null,
				periodo: filtro.periodo || null,
				serie: filtro.serie || null,
				folio: filtro.folio || null,
				uuid: filtro.uuid || null,
				fecha_inicio: fecha_inicio || null,
				fecha_fin: fecha_fin || null,
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Donwload', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	ListarDownloadFac: (filtro) => {
		console.log('FILTRO', filtro);
		let fecha_inicio = (filtro.fecha_inicio || null) ? DateFormat.FormatSql(filtro.fecha_inicio) : null;
		let fecha_fin = (filtro.fecha_fin || null) ? DateFormat.FormatSql(filtro.fecha_fin) : null;
		
		let params = {
			filtro: {
				id_facturacion: filtro.id_facturacion || null,
				id_usuario: filtro.id_usuario || null,
				id_rocket_chat: filtro.id_rocket_chat || null,
				id_plaza: filtro.id_plaza || null,
				empresa: filtro.empresa || null,
				cliente: filtro.cliente || null,
				id_cat_forma_pago: filtro.id_cat_forma_pago || null,
				id_cat_metodo_pago: filtro.id_cat_metodo_pago || null,
				id_cat_facturacion_estatus: filtro.id_cat_facturacion_estatus || null,
				id_cat_facturacion_status_sat: filtro.id_cat_facturacion_status_sat || null,
				id_cat_facturacion_status_pago: filtro.id_cat_facturacion_status_pago || null,
				anio: filtro.anio || null,
				periodo: filtro.periodo || null,
				serie: filtro.serie || null,
				folio: filtro.folio || null,
				uuid: filtro.uuid || null,
				fecha_inicio: fecha_inicio || null,
				fecha_fin: fecha_fin || null,
				id_proyecto: 1
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Donwload_Fac', params, {facturacion: true}).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Excel: (filtro, paginacion, archivo) => {
		console.log('PAGINACION', paginacion);
		let params = {
			empresa: filtro.empresa || null,
			cliente: filtro.cliente || null,
			id_cat_facturacion_status_sat: filtro.id_cat_facturacion_status_sat || null,
			id_cat_facturacion_status_pago: filtro.id_cat_facturacion_status_pago || null,
			id_cat_facturacion_plaza: filtro.id_cat_facturacion_plaza || null,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.export('_Carga_CFDI_Datos_Excel', ['Cargo', 'CFDI'], params, false, false, false, archivo === "EXCEL", (response) => {
				resolve(response);
				this.setState({
					to: '',
					cc: '',
					to_name: '',
					subject: '',
					mensaje: '',
				});
			}, (error) => {
				reject(error);
			});
		});
	},
	ListarTodo: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Datos_All', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Detalles: (id_facturacion) => {
		let params = {
			id_facturacion: id_facturacion,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Detalle', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Guardar: (form) => {
		let params = {
			id_cliente: form.select_cliente.id_cliente,
			project: form.project,
			archivos: form.archivos,
			xmls: form.jsonXML,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Agregar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	GuardarX: (form) => {
		let params = {
			id_cliente: form.select_cliente.id_cliente,
			archivos: form.archivos,
			fecha_pago: form.fecha_pago,
			xmls: form.jsonXML,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Agregar_X', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	GuardarPDF: (form) => {
		let params = {
			archivos: form.archivos,
			project: form.project,
			xmls: form.jsonXML,
			activo: form.activo ? 1 : 0,
			pdf: form.pdf ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Agregar_PDF', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_sexo: form.id_cat_sexo,
			sexo: form.sexo,
			abreviatura: form.abreviatura,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Nube_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_facturacion_cfdi) => {
		let params = {
			id_facturacion_cfdi: id_facturacion_cfdi
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Pagar: (form) => {
		let fecha_pago = form.fecha_pago && form.fecha_pago !== 'NaN-NaN-NaN' ? DateFormat.FormatSql(form.fecha_pago) : '';
		let params = {
			id_cliente: form.id_cliente,
			id_facturacion_cfdi: form.id_facturacion_cfdi,
			tipo_pago: form.tipo_pago,
			fecha_pago: fecha_pago,
			archivos: form.archivos,
			xmls: form.jsonXML,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Pagar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Cancelar: (form) => {
		let fecha_cancelacion = form.fecha_cancelacion && form.fecha_cancelacion !== 'NaN-NaN-NaN' ? DateFormat.FormatSql(form.fecha_cancelacion) : '';
		let params = {
			id_cliente: form.id_cliente,
			id_facturacion_cfdi: form.id_facturacion_cfdi,
			id_facturacion_cfdi_parcial: form.id_facturacion_cfdi_parcial || '',
			fecha_cancelacion: fecha_cancelacion,
			folio_fiscal_sustituye: form.folio_fiscal_sustituye,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Cancelar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Pdf: (form) => {
		let params = {
			id_facturacion_cfdi: form.id_facturacion_cfdi || '',
			id_facturacion_cfdi_parcial: form.id_facturacion_cfdi_parcial || '',
			archivo_pdf: form.archivos[0],
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_PDF', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Observacion: (form) => {
		let params = {
			id_cliente: form.id_cliente,
			id_facturacion_cfdi: form.id_facturacion_cfdi,
			id_facturacion_cfdi_parcial: form.id_facturacion_cfdi_parcial || '',
			observacion: form.observacion,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Observacion', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	SendEmail: (form) => {
		let params = {
			id_cliente: form.id_cliente,
			id_facturacion_cfdi: form.id_facturacion_cfdi,
			correo_electronico: form.correo_electronico || '',
			asunto: form.asunto || '',
			mensaje: form.mensaje,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_SendEmail', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	SubirArchivoVerificacion: (form) => {
		let params = {
			comprobante_archivo: form.comprobante_archivo,
			comprobante_formato: form.comprobante_formato,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Carga_CFDI_Verificacion', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
